import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-msg-dialog',
  templateUrl: './msg-dialog.component.html',
  styleUrls: ['./msg-dialog.component.css']
})
export class MsgDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
